/**
 * Contact Book Arche Page
 *
 * Route wrapper: ArcheLayout + ArcheHeader + Routes for the contact book arche.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ArcheHeader } from '../../../components/ArcheHeader';
import { ARCHE_ID } from '../constants';
import { ContactBookContent } from './ContactBookPage';

export function ContactBookArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <ArcheHeader archeId={ARCHE_ID} title="Contact Book" />
        <div className="flex-1 overflow-hidden">
          <Routes>
            <Route path="/" element={<ContactBookContent />} />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
